"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@record-import/success",
  ERROR: "@@record-import/error",
  IMPORT_RECORDS_VALIDATION: "@@record-import/import-records-validation",
  VALIDATE_RECORD_GIVINGS: "@@record-import/validate-record-givings",
  VALIDATE_RECORD_FY_DOWNLOAD: "@@record-import/validate-record-fy-download",
  IMPORT_RECORDS: "@@record-import/import-records",
  IMPORT_RECORDS_FY_DOWNLOADS: "@@record-import/import-records-fy-downloads",
  UPDATE_RECORD_GIVINGS: "@@record-import/update-record-givings",
  RECORDS_VALIDATION_ERROR_DOWNLOAD: "@@record-import/records-validation-error-download",
  RECORDS_FY_VALIDATION_ERROR_DOWNLOAD: "@@record-import/records-fy-validation-error-download",
  DOWNLOAD_RECORD_GIVING_ERROR_SHEET: "@@record-import/download-record-giving-error-sheet",
  RESET: "@@record-import/reset"
};
exports.actionTypes = actionTypes;